export default __webpack_public_path__ + "static/media/Prophecy_3x2_Cn.1d0c18be.webp";